import { Button, Form, Input, message } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { resetPassword } from "../../../controller/services/auth";
import useFormValidation from "../../../hooks/useFormValid";
import i18n from "../../../localization/i18n";
import { setLoading } from "../../../redux/slices/common_slice";
import { routePaths } from "../../../routing/routePaths";
import { getApiErrorMessage } from "../../../utils/helper";
import CardWrapper from "./CardWrapper";

const ResetPassword = () => {
  const [form] = Form.useForm();
  const { formValid, handleValuesChange, formValues } = useFormValidation(form);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const params = useLocation();
  const dispatch = useDispatch();
  const onFinish = (values) => {
    dispatch(setLoading(true));
    const payload = {
      email: params.state.email,
      password: values.password,
    };
    resetPassword(payload)
      .then((resp) => {
        message.success(resp?.message?.[i18n.language]);
        navigate(routePaths.login);
      })
      .catch((err) => {
        message.error(getApiErrorMessage(err, t("errors.requestFailed")));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  useEffect(() => {
    if (formValues.password && formValues.confirmPassword) {
      if (formValues.password != formValues.confirmPassword) {
        form.validateFields("");
      }
    }
  }, [formValues.password, formValues.confirmPassword]);
  return (
    <>
      <CardWrapper>
        <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 mx-auto select-language-details">
          <Link
            to={routePaths.verificationCode}
            state={{
              email: params.state?.email,
            }}
            className="back-arrow-btn"
          >
            <img
              alt=""
              className="img-fluid"
              src="/assets/images/icons/back-arrow-with-bg.svg"
            />
          </Link>
          <h1>{t("resetPassword")}</h1>
          <p>{t("resetPassDesc")}</p>
          <div className="row">
            <div className="col-12 reset-password-form">
              <Form
                className="common-form"
                name="basic"
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinish}
                autoComplete="off"
                form={form}
                onValuesChange={handleValuesChange}
              >
                <Form.Item
                  label={false}
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: t("errors.password"),
                    },
                    {
                      pattern:
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-={}\[\]:;"'<>,./?|\\])[A-Za-z\d!@#$%^&*()_+\-={}\[\]:;"'<>,./?|\\]{8,}$/,
                      message: t("errors.validPass"),
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (value.length <= 50) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error(t("errors.maxLimit")));
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    prefix={
                      <img
                        alt=""
                        className="img-fluid"
                        src={
                          formValues?.password
                            ? "/assets/images/icons/lock-icon-primary.svg"
                            : "/assets/images/icons/lock-icon.svg"
                        }
                      />
                    }
                    iconRender={(visible) =>
                      visible ? (
                        <img
                          alt=""
                          className="img-fluid"
                          src="/assets/images/icons/eye-icon-primary.svg"
                        />
                      ) : (
                        <img
                          alt=""
                          className="img-fluid"
                          src="/assets/images/icons/hide-eye-icon.svg"
                        />
                      )
                    }
                    placeholder={t("enterPassword")}
                  />
                </Form.Item>
                <Form.Item
                  label={false}
                  name="confirmPassword"
                  dependencies={["password"]}
                  rules={[
                    {
                      required: true,
                      message: t("errors.password"),
                    },
                    {
                      pattern:
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-={}\[\]:;"'<>,./?|\\])[A-Za-z\d!@#$%^&*()_+\-={}\[\]:;"'<>,./?|\\]{8,}$/,
                      message: t("errors.validPass"),
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error(t("errors.matchPass")));
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    prefix={
                      <img
                        alt=""
                        className="img-fluid"
                        src={
                          formValues?.confirmPassword
                            ? "/assets/images/icons/lock-icon-primary.svg"
                            : "/assets/images/icons/lock-icon.svg"
                        }
                      />
                    }
                    iconRender={(visible) =>
                      visible ? (
                        <img
                          alt=""
                          className="img-fluid"
                          src="/assets/images/icons/eye-icon-primary.svg"
                        />
                      ) : (
                        <img
                          alt=""
                          className="img-fluid"
                          src="/assets/images/icons/hide-eye-icon.svg"
                        />
                      )
                    }
                    placeholder={t("enterConfirmPassword")}
                  />
                </Form.Item>
                <Form.Item>
                  <Button
                    className="auth-theme-btn auth-login-btn auth-theme-btn-fix"
                    type="primary"
                    htmlType="submit"
                    disabled={
                      !formValues.confirmPassword ||
                      !formValues.password ||
                      !formValid ||
                      form.getFieldError()?.length > 0
                    }
                  >
                    {t("continue")}
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </CardWrapper>
    </>
  );
};

export default ResetPassword;
